export default __webpack_public_path__ + "img/f93f3282e344cb899d3368bd5423a7c9.png";